import { API_ROOT } from '../../config/config'
import { doGet, doPost } from './utils'

export const getSchemaStrategic = (projectId) => {
  const url = `${API_ROOT}/review/${projectId}/strategic`
  return doGet(url)
}

export const getProposalStrategic = (projectId) => {
  const url = `${API_ROOT}/proposal/${projectId}/strategy`
  return doGet(url)
}

export const saveStrategic = (request) => {
  const url = `${API_ROOT}/review/strategic`
  return doPost(url, request)
}

export const saveStrategicPercent = (request) => {
  const url = `${API_ROOT}/review/strategic/percent`
  return doPost(url, request)
}

//หลายโครงการ
export const getStrategySchema = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/strategy/page/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const getStrategyData = (request, pagesize, pagenumber) => {
  const url = `${API_ROOT}/multiple/strategy/list/${pagesize}/pagenumber/${pagenumber}`
  return doPost(url, request)
}

export const saveStrategyMuti = (request) => {
  const url = `${API_ROOT}/multiple/strategy/add`
  return doPost(url, request)
}

export const saveStrategyPercentMuti = (request) => {
  const url = `${API_ROOT}/multiple/strategy/percent/add`
  return doPost(url, request)
}
